import { Download } from 'lucide-react';
import { Button } from '@ui/button.tsx';
import { downloadCSV } from '@r/utils/utils.ts';
import type { HTMLAttributes } from 'react';

interface ExampleFileProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Unique identifier of the component.
   * @type string
   * @default undefined
   * @example id='example'
   */
  id?: string;

  /**
   * Content of the csv.
   * @type string
   * @default undefined
   * @example csv='example, example'
   */
  csv: string | null;

  /**
   * Name of the file.
   * @type string
   * @default download.csv
   * @example filename='example, example'
   */
  filename?: string;

  /**
   * Label of the button.
   * @type string
   * @default undefined
   * @example label='example'
   */
  label?: string;

  /**
   * Classname of the button.
   * @type string
   * @default undefined
   * @example className='example'
   */
  className?: string;
}

export const CsvFile = (props: ExampleFileProps) => {
  const { id, className = 'pl-1', csv, filename: fileNameProps, label = 'Télécharger' } = props;
  const handleClick = csv ? () => downloadCSV(csv, fileNameProps) : undefined;

  return (
    <div className={className}>
      <Button
        id={id}
        variant={'outline'}
        rounded="full"
        className="uppercase"
        onClick={handleClick}
      >
        <Download className="mr-2 w-4 h-4" />
        {label}
      </Button>
    </div>
  );
};
